import { g as n } from "../../utils-BOfnFgIH.js";
import { I as o } from "../../constants-DeVuDy8J.js";
import { openBlock as r, createElementBlock as s, normalizeClass as d, createElementVNode as e } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const p = {
  name: "DtIconFront",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (t) => Object.keys(o).includes(t)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return o[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = n();
  }
}, f = ["aria-label", "data-qa", "aria-hidden"], c = ["fill"], m = ["fill"], _ = ["id"], h = ["id"];
function g(t, a, l, F, I, i) {
  return r(), s("svg", {
    "aria-label": l.ariaLabel,
    class: d([i.iconSizeClass, "d-icon d-icon--front"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Front",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a[2] || (a[2] = e("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.223 5.45a3.302 3.302 0 0 1 3.302-3.302h10.59v4.7a1.65 1.65 0 0 1-1.65 1.651h-4.33a1.588 1.588 0 0 0-1.561 1.566v10.279c0 .912-.74 1.65-1.651 1.65h-4.7V5.452z",
      fill: "#001B38"
    }, null, -1)),
    e("path", {
      d: "M8.914 10.127a4.287 4.287 0 1 0 8.574 0 4.287 4.287 0 0 0-8.574 0z",
      fill: `url(#${t.uniqueID}a)`
    }, null, 8, c),
    e("path", {
      opacity: ".5",
      d: "M8.914 10.127a4.287 4.287 0 1 0 8.574 0 4.287 4.287 0 0 0-8.574 0z",
      fill: `url(#${t.uniqueID}b)`
    }, null, 8, m),
    e("defs", null, [
      e("linearGradient", {
        id: `${t.uniqueID}a`,
        x1: "10.182",
        y1: "6.913",
        x2: "16.629",
        y2: "13.404",
        gradientUnits: "userSpaceOnUse"
      }, [...a[0] || (a[0] = [
        e("stop", {
          "stop-color": "#FF0057",
          "stop-opacity": ".16"
        }, null, -1),
        e("stop", {
          offset: ".861",
          "stop-color": "#FF0057"
        }, null, -1)
      ])], 8, _),
      e("linearGradient", {
        id: `${t.uniqueID}b`,
        x1: "10.182",
        y1: "6.913",
        x2: "16.629",
        y2: "13.404",
        gradientUnits: "userSpaceOnUse"
      }, [...a[1] || (a[1] = [
        e("stop", {
          "stop-color": "#FF0057",
          "stop-opacity": ".16"
        }, null, -1),
        e("stop", {
          offset: ".861",
          "stop-color": "#FF0057"
        }, null, -1)
      ])], 8, h)
    ])
  ], 10, f);
}
const S = /* @__PURE__ */ u(p, [["render", g]]);
export {
  S as default
};
//# sourceMappingURL=front.js.map
